import React from "react";

function Coil() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64.897"
      height="58.15"
      version="1.1"
      viewBox="0 0 17.171 15.385"
      className="coil"
    >
      <defs>
        <marker
          id="Dot"
          markerHeight="2.667"
          markerWidth="2.667"
          orient="auto"
          overflow="visible"
          preserveAspectRatio="xMidYMid"
          refX="0"
          refY="0"
          viewBox="0 0 5.667 5.667"
        >
          <path
            fill="context-stroke"
            fillRule="evenodd"
            stroke="context-stroke"
            strokeWidth=".5pt"
            d="M2.5 0a2.5 2.5 0 01-5 0c0-1.38 1.15-2.5 2.5-2.5A2.5 2.5 0 012.5 0z"
          ></path>
        </marker>
        <marker
          id="marker5343"
          markerHeight="1.667"
          markerWidth="1.667"
          orient="auto"
          overflow="visible"
          preserveAspectRatio="xMidYMid"
          refX="0"
          refY="0"
          viewBox="0 0 5.667 5.667"
        >
          <path
            fill="context-stroke"
            fillRule="evenodd"
            stroke="context-stroke"
            strokeWidth=".5pt"
            d="M2.5 0a2.5 2.5 0 01-5 0c0-1.38 1.15-2.5 2.5-2.5A2.5 2.5 0 012.5 0z"
          ></path>
        </marker>
      </defs>
      <g transform="translate(-114.745 -168.494)">
        <g
          stroke="#fff"
          strokeDasharray="none"
          strokeOpacity="1"
          transform="translate(68.5 101.018)"
        >
          <g
            fill="none"
            strokeWidth="0.779"
            paintOrder="stroke markers fill"
            transform="matrix(.57222 0 0 .53929 -3.31 -5.432)"
          >
            <path
              strokeDashoffset="0"
              strokeWidth="0.779"
            //   markerStart="url(#Dot)"
              d="M90.475 142.952a13.67 13.874 0 0115.862-6.827 13.67 13.874 0 019.846 14.35 13.67 13.874 0 01-11.81 12.731 13.67 13.874 0 01-14.706-9.11"
            ></path>
            <path
              strokeWidth="0.779"
              d="M92.486 146.768a10.468 10.469 0 0111.257-7.583 10.468 10.469 0 019.28 9.907 10.468 10.469 0 01-8.302 10.74 10.468 10.469 0 01-11.924-6.485"
            ></path>
            <path
              strokeDashoffset="0"
              strokeWidth="0.794"
              d="M94.582 147.235a8.065 7.92 0 018.633-5.593 8.065 7.92 0 017.14 7.35 8.065 7.92 0 01-6.096 8.205 8.065 7.92 0 01-9.306-4.432"
            ></path>
            <path
              strokeWidth="0.809"
              d="M96.542 147.859a6.055 6.13 0 016.35-4.622 6.055 6.13 0 015.554 5.575 6.055 6.13 0 01-4.509 6.47 6.055 6.13 0 01-7.049-3.43"
            ></path>
            <path
              strokeWidth="0.821"
            //   markerEnd="url(#marker5343)"
              d="M97.835 148.386a4.667 4.669 0 014.175-3.722 4.667 4.669 0 014.748 2.957 4.667 4.669 0 01-1.497 5.39 4.667 4.669 0 01-5.593.084"
            ></path>
          </g>
          <path
            fill="#fff"
            fillOpacity="1"
            strokeWidth="0.389"
            d="M54.86 75.54l-8.417-3.237.05 6.037z"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Coil;